import * as loadingState from '../constants/loadingState';

export const EDIT_ACCOUNT_INITIALIZE = 'EDIT_ACCOUNT_INITIALIZE';
export const EDIT_ACCOUNT = 'EDIT_ACCOUNT';
export const EDIT_ACCOUNT_SUCCESS = 'EDIT_ACCOUNT_SUCCESS';
export const UPDATE_TUTOR_AVATAR = 'UPDATE_TUTOR_AVATAR';
export const UPDATE_TUTOR_AVATAR_SUCCESS = 'UPDATE_TUTOR_AVATAR_SUCCESS';
export const UPDATE_TUTOR_AVATAR_FAILURE = 'UPDATE_TUTOR_AVATAR_FAILURE';
export const EDIT_ACCOUNT_FAILURE = 'EDIT_ACCOUNT_FAILURE';
export const EDIT_ACCOUNT_COMPLETE = 'EDIT_ACCOUNT_COMPLETE';
export const RESET_EDIT_ACCOUNT_STATUS = 'RESET_EDIT_ACCOUNT_STATUS';
export const CLOSE_EDIT_PANEL = 'CLOSE_EDIT_PANEL';
export const SHOW_INVALID_WORD_MODAL = 'SHOW_INVALID_WORD_MODAL';
export const HIDE_INVALID_WORD_MODAL = 'HIDE_INVALID_WORD_MODAL';

export const editAccountInitialize = () => ({ type: EDIT_ACCOUNT_INITIALIZE });

export const editAccount = (data, showBannerAfterSuccess = false) => ({
  type: EDIT_ACCOUNT,
  payload: {
    data,
    showBannerAfterSuccess,
  },
});

export const editAccountSuccess = () => ({ type: EDIT_ACCOUNT_SUCCESS });

export const editAccountFailure = errorMessage => ({
  type: EDIT_ACCOUNT_FAILURE,
  payload: {
    errorMessage,
  },
});

export const updateTutorAvatar = payload => ({
  type: UPDATE_TUTOR_AVATAR,
  payload,
});

export const updateTutorAvatarSuccess = () => ({
  type: UPDATE_TUTOR_AVATAR_SUCCESS,
});
export const updateTutorAvatarFailure = () => ({
  type: UPDATE_TUTOR_AVATAR_FAILURE,
});

export const resetEditAccountStatus = () => ({
  type: RESET_EDIT_ACCOUNT_STATUS,
});

export const editAccountComplete = () => ({ type: EDIT_ACCOUNT_COMPLETE });

export const closeEditPanel = () => ({ type: CLOSE_EDIT_PANEL });

export const showInvalidWordModal = () => ({ type: SHOW_INVALID_WORD_MODAL });
export const hideInvalidWordModal = () => ({ type: HIDE_INVALID_WORD_MODAL });

const INIT_STATE = {
  editAccountOpen: false,
  isInvalidWordModalOpen: false,
  editAccountStatus: loadingState.EMPTY,
  errorMessage: '',
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case EDIT_ACCOUNT_INITIALIZE:
      return {
        ...state,
        editAccountStatus: loadingState.EMPTY,
        editAccountOpen: true,
        errorMessage: '',
      };

    case RESET_EDIT_ACCOUNT_STATUS:
      return INIT_STATE;

    case EDIT_ACCOUNT:
      return {
        ...state,
        editAccountStatus: loadingState.LOADING,
      };
    case UPDATE_TUTOR_AVATAR:
      return {
        ...state,
        status: loadingState.LOADING,
      };
    case EDIT_ACCOUNT_SUCCESS:
      return {
        ...state,
        editAccountStatus: loadingState.READY,
        editAccountOpen: false,
        errorMessage: '',
      };
    case EDIT_ACCOUNT_FAILURE:
      return {
        ...state,
        editAccountStatus: loadingState.ERROR,
        errorMessage: action.payload.errorMessage,
      };
    case UPDATE_TUTOR_AVATAR_SUCCESS:
      return {
        ...state,
        editAccountStatus: loadingState.READY,
      };
    case UPDATE_TUTOR_AVATAR_FAILURE:
      return {
        ...state,
        editAccountStatus: loadingState.ERROR,
      };

    case EDIT_ACCOUNT_COMPLETE:
      return {
        ...state,
        editAccountStatus: loadingState.EMPTY,
        editAccountOpen: false,
        errorMessage: '',
      };

    case CLOSE_EDIT_PANEL:
      return {
        ...state,
        editAccountOpen: false,
      };
    case SHOW_INVALID_WORD_MODAL:
      return {
        ...state,
        isInvalidWordModalOpen: true,
      };
    case HIDE_INVALID_WORD_MODAL:
      return {
        ...state,
        isInvalidWordModalOpen: false,
      };

    default:
      return state;
  }
};

export default reducer;

export const getIsInvalidWordModalOpen = state =>
  state.editAccount.isInvalidWordModalOpen;
export const getEditAccountStatus = state =>
  state.editAccount.editAccountStatus;



// WEBPACK FOOTER //
// ./app/redux/editAccount.js